import React from 'react';
import { LondonBetMainLogo, LondonBetMainLogoWrapper } from 'src/domains/common/universes/londonbet/londonbet.style';

export const LondonbetLogotype = (): JSX.Element => (
    <LondonBetMainLogoWrapper>
        <LondonBetMainLogo />
    </LondonBetMainLogoWrapper>
);
